import { MoreVert } from '@mui/icons-material';
import {
  Menu,
  MenuItem,
  IconButton,
  Button,
  MenuList,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
const PREFIX = 'ContextualMenu';
const classes = {
  menuList: `${PREFIX}-menuList`,
  menuItem: `${PREFIX}-menuItem`,
};
const StyledMenu = styled(Menu)(({ theme }) => ({
  [`& .${classes.menuList}`]: {
    padding: theme.spacing(0),
  },
  [`& .${classes.menuItem}`]: {
    '& .MuiSvgIcon-root': {
      fill: theme.palette.text.secondary,
      marginRight: theme.spacing(1),
    },
  },
}));

const GenContextualMenu = ({
  type = 'icon',
  iconButtonIcon = <MoreVert />,
  ButtonText = 'button',
  size = 'large',
  buttonId = 'genContextualButton',
  menuId = 'genPopMenuId',
  options = [],
  anchorPosition = {
    vertical: 'top',
    horizontal: 'right',
  },
  transformOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  sx = {},
  iconColor = 'rgba(0, 0, 0, 0.54)',
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = e => {
    e.preventDefault();
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleClickOption = (option, event) => {
    handleClose(event);
    (option.onClick || (() => {}))();
  };

  return (
    <>
      {type === 'icon' ? (
        <IconButton
          id={buttonId}
          aria-controls={menuId}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onMouseDown={event => event.stopPropagation()}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            handleClick(event);
          }}
          size={size}
          sx={{ color: iconColor }}
        >
          {iconButtonIcon}
        </IconButton>
      ) : (
        <Button
          id={buttonId}
          aria-controls={menuId}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant={type}
          sx={sx}
          onMouseDown={event => event.stopPropagation()}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            handleClick(event);
          }}
          size={size}
        >
          {ButtonText}
        </Button>
      )}
      <StyledMenu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        label={buttonId}
        anchorOrigin={{
          vertical: anchorPosition.vertical,
          horizontal: anchorPosition.horizontal,
        }}
        transformOrigin={{
          vertical: transformOrigin.vertical,
          horizontal: transformOrigin.horizontal,
        }}
      >
        <MenuList className={classes.menuList}>
          {options.map((item, index) => (
            <Tooltip
              title={(item.disabled && item.disabledTooltip) || ''}
              key={index}
              arrow
            >
              <span>
                <MenuItem
                  disableRipple
                  disabled={item.disabled}
                  key={index}
                  onClick={event => handleClickOption(item, event)}
                  className={classes.menuItem}
                >
                  {item.icon}
                  {item.name}
                </MenuItem>
              </span>
            </Tooltip>
          ))}
        </MenuList>
      </StyledMenu>
    </>
  );
};

export default GenContextualMenu;
